<template>
<i v-if="type !== 'svg'" :class="_class"></i>
<img v-else v-bind:src="path" />
</template>

<script>
export default {
    props: {
        // type: flaticon|socicon|fa|la|svg
        type: {
            type: String,
            default: 'fa'
        },
        name: {
            type: String,
            required: true,
        },
        path: [String]
    },
    computed: {
        _class: function() {
            if(this.type === 'svg') {
                return []
            }

            let _class = []

            _class.push(this.type+'-'+this.name)

            if(this.type === 'la' || this.type === 'fa') {
                _class.push(this.type)
            }

            return _class
        }
    }
}
</script>